import Holidays from 'date-holidays'
import { HOLIDAY_IDS, type HolidayId } from '@/constants/holiday-hours'

/**
 * Same name→id rules as automotive-api `holidayNameToId` so UI dates match API resolution.
 */
function holidayNameToId(name: string): HolidayId | null {
  if (name.includes('New Year') && !name.includes('Eve')) return 'NEW_YEARS_DAY'
  if (name.includes('Martin Luther King')) return 'MLK_DAY'
  if (name.includes('President') || name.includes('Washington')) return 'PRESIDENTS_DAY'
  if (name === 'Memorial Day') return 'MEMORIAL_DAY'
  if (name.includes('Easter')) return 'EASTER'
  if (name.includes('Independence')) return 'INDEPENDENCE_DAY'
  if (name === 'Labor Day') return 'LABOR_DAY'
  if (name.includes('Veterans')) return 'VETERANS_DAY'
  if (name.includes('Thanksgiving') && !name.includes('after')) return 'THANKSGIVING'
  if (name.includes('Christmas') && !name.includes('Eve')) return 'CHRISTMAS'
  return null
}

const monthDayFormatter = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric' })

/**
 * Calendar month/day labels for each catalog holiday in `year` (US, America/Chicago).
 * When a holiday has both a substitute day and the calendar day (e.g. Independence Day), prefers the non-substitute entry.
 */
export function getHolidayMonthDayLabels(year: number): Record<HolidayId, string> {
  const hd = new Holidays('US', { timezone: 'America/Chicago' })
  const rows = hd.getHolidays(year)
  const best = new Map<HolidayId, { start: Date; substitute: boolean }>()

  for (const h of rows) {
    const id = holidayNameToId(h.name)
    if (!id) continue
    const substitute = Boolean(h.substitute)
    const prev = best.get(id)
    if (!prev) {
      best.set(id, { start: h.start, substitute })
    } else if (prev.substitute && !substitute) {
      best.set(id, { start: h.start, substitute })
    }
  }

  const out = {} as Record<HolidayId, string>
  for (const id of HOLIDAY_IDS) {
    const b = best.get(id)
    out[id] = b ? monthDayFormatter.format(b.start) : '—'
  }
  return out
}
